import React from 'react';
import { Outlet } from "react-router";

const EncounterLayout = () => {
    return (
        <Outlet />
    );
};

export default EncounterLayout;